export default "__VITE_ASSET__A5yvYXCN__"